import { render } from "./componentsLayout.vue?vue&type=template&id=175e3ec6&scoped=true"
import script from "./componentsLayout.vue?vue&type=script&lang=js"
export * from "./componentsLayout.vue?vue&type=script&lang=js"

import "./componentsLayout.vue?vue&type=style&index=0&id=175e3ec6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Scott\\Desktop\\HTML\\FinalLandingPage\\final-landing-page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-175e3ec6"]])

export default __exports__